<template>
  <v-container
    text-xs-center
  >
    <v-card
      v-show="!loading"
      flat
      class="mx-auto animated fadeIn delay-1s pa-2 pb-5 mb-5"
    >
      <v-layout
        row
        wrap
        justify-end
        style="align-items: center"
      >
        <v-flex
          xs5
          style="text-align: start;"
        >
          <v-btn
            flat
            icon
            class="back-to-catalogue-btn"
            block
            color="primary"
            @click="goBack()"
          >
            <v-icon class="mr-2">
              $vuetify.icons.arrowLeftIcon
            </v-icon>
            Voltar
          </v-btn>
        </v-flex>

        <v-flex xs1 />

        <!-- Clear cart session -->
        <v-flex
          xs6
          style="text-align: end;"
        >
          <v-dialog
            v-model="dialogClear"
            max-width="317"
          >
            <template #activator="{ on }">
              <v-btn
                :disabled="!hasProducts"
                small
                round
                depressed
                class="px-4 cart__clear-btn"
                v-on="on"
              >
                <v-icon
                  small
                  class="mr-2"
                >
                  mdi-delete
                </v-icon>
                Limpar seleção
              </v-btn>
            </template>

            <ActionsDialog
              :dialog-text="`${sellerFirstName}, você tem certeza que deseja limpar a seleção?`"
              first-text="Não, quero manter a seleção"
              second-text="Limpar seleção"
              :first-action="() => { dialogClear = false }"
              :second-action="clearCheckout"
              :close="() => { dialogClear = false }"
            />
          </v-dialog>
        </v-flex>

        <!-- Customer name and Store name session -->
        <v-flex
          v-show="hasProducts"
          xs12
          class="cart__store-seller mt-3"
          @click="foo()"
        >
          <span>{{ getCustomer.name }} - {{ getStore.name }}</span>
        </v-flex>

        <!-- Quantities products selected session -->
        <v-flex
          v-show="hasProducts"
          xs12
          class="cart__size mt-2"
        >
          <span>{{ productsAccepted.length }} {{ productsAccepted.length > 1 ? 'itens selecionados' : 'item selecionado' }}</span>
        </v-flex>
      </v-layout>

      <!-- Cart is empty session-->
      <v-layout
        v-show="!hasProducts"
        class="py-5"
      >
        <v-flex xs12>
          <span
            class="cart__empty"
          >
            Seu catálogo está vazio
            <v-icon
              left
              color="#433D4E"
              class="ml-2"
            > $vuetify.icons.scaredEmojiIcon
            </v-icon>
          </span>
          <h4 class="my-4 cart__empty__subtitle">
            Adicione produtos para gerar um catálogo personalizado.
          </h4>
          <v-divider style="border: 1px solid #DDDDDD;" />
        </v-flex>
      </v-layout>

      <v-layout
        v-show="hasProducts"
        class="products-catalogue-wrapper"
      >
        <v-flex
          v-for="(product, index) in getCatalogue"
          :key="`${index}--${product.reference}`"
          xs12
          style="border-bottom: 1px solid #DDDDDD;"
        >
          <div
            v-if="product.status === 'PENDING'"
            class="zerostock-warning mt-3"
          >
            Produto sem estoque. Aguardando aceite da gerência.
          </div>

          <div
            v-if="product.status === 'APPROVED'"
            class="zerostock-warning mt-3"
            style="background: #3D6961"
          >
            Solicitação aceita com sucesso!
          </div>

          <DeclinedApprovalProduct
            v-if="product.status === 'DECLINED'"
            :product="product"
          />

          <CartProduct
            v-if="product && !product.status || product.status !== 'DECLINED'"
            :product="product"
            :store-id="getStoreOMS ? getStoreOMS.id : 0"
            :toggle-product-dialog="toggleProductDialog"
          />
        </v-flex>

        <!-- Dialog remove product -->
        <v-dialog
          v-model="productDialogs.exclude"
          persistent
          max-width="317"
        >
          <ActionsDialog
            dialog-text="Deseja excluir o produto?"
            first-text="Cancelar"
            second-text="Excluir"
            :first-action="() => { productDialogs.exclude = false }"
            :second-action="() => { removeProduct(productToDialog) }"
            :close="() => { productDialogs.exclude = false }"
          />
        </v-dialog>

        <!-- Dialog edit product -->
        <v-dialog
          v-if="productDialogs.edit"
          v-model="productDialogs.edit"
          hide-overlay
          persistent
          content-class="product-edit-dialog"
        >
          <ProductEditDialog
            :product="productToDialog"
            :store="store"
            @close="() => {
              productToDialog = {},
              productDialogs.edit = false
            }"
          />
        </v-dialog>

        <!-- Dialog services -->
        <v-dialog
          v-if="productDialogs.services"
          v-model="productDialogs.services"
          persistent
          max-width="330"
        >
          <ServicesDialog
            :product="productToDialog"
            :quantity="productToDialog.quantity"
            @finish-services="saveProduct"
            @change-quantity-services="changeQuantityWarranty"
            @close="() => { productDialogs.services = false, productToDialog = {} }"
          />
        </v-dialog>

        <!-- Dialog Warranty mobile -->
        <v-dialog
          v-if="productDialogs.warrantyMobile"
          v-model="productDialogs.warrantyMobile"
          persistent
          max-width="330"
        >
          <WarrantyMobileDialog
            :product="productToDialog"
            :quantity="productToDialog.quantity"
            @finish-warranty="saveProduct"
            @change-quantity-warranty="changeQuantityWarranty"
            @close="() => { productDialogs.warrantyMobile = false, productToDialog = {} }"
          />
        </v-dialog>

        <!-- Dialogs warranties (skuAddOns) -->
        <v-dialog
          v-if="productDialogs.warranty"
          v-model="productDialogs.warranty"
          persistent
          max-width="330"
        >
          <WarrantyDialog
            :product="productToDialog"
            :quantity="productToDialog.quantity"
            @finish-warranty="saveProduct"
            @change-quantity-warranty="changeQuantityWarranty"
            @close="() => { productDialogs.warranty = false, productToDialog = {} }"
          />
        </v-dialog>
      </v-layout>

      <!-- to be used in upcoming versions of sales assistant -->
      <!-- <v-expansion-panel
        v-if="getCustomer.salesAssistant && hasProducts"
        expand
        block
        depressed
        flat
        style="padding: 10px 0px 20px"
      >
        <v-expansion-panel-content class="apply-discount">
          <template #header>
            <div class="apply-discount__title">
              Aplicar desconto
            </div>
          </template>
          <div class="d-flex">
            <v-container>
              <v-layout
                row
                wrap
              >
                <v-flex xs8>
                  <v-text-field
                    v-model="discountCode"
                    class="apply-discount__text_input"
                    outlined
                    solo
                    flat
                    label="Código do cupom"
                  />
                </v-flex>
                <v-flex xs4>
                  <v-btn
                    class="apply-discount__button"
                    block
                    depressed
                    color="#140C22"
                    @click="applyDiscount"
                  >
                    Adicionar
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel> -->

      <!-- Purchase resume session -->
      <v-container
        v-if="hasProducts && getCustomer.salesAssistant"
        style="padding: 0"
      >
        <v-layout class="order__summary">
          <span class="order__summary__title">
            Resumo da compra
          </span>
          <div class="order__subtotal d-flex justify-space-between">
            <span class="text-xs-left">Subtotal</span>
            <span class="text-xs-right">{{ totalCost | currency }}</span>
          </div>
          <div class="order__total d-flex justify-space-between">
            <span class="text-xs-left">TOTAL</span>
            <span class="text-xs-right">{{ totalCost | currency }}</span>
          </div>
        </v-layout>
      </v-container>

      <!-- Actions cart session -->
      <v-card-actions class="d-block justify-center mx-0 mt-1">
        <v-btn
          v-if="getCatalogueId"
          block
          depressed
          color="#140C22"
          class="generate-catalogue-btn px-1"
          :loading="loadingCopy"
          :disabled="loading || !hasProducts"
          @click="catalogueAction"
        >
          {{ isCatalogue ? 'Atualizar Catálogo' : 'Gerar Catálogo' }}
        </v-btn>

        <v-dialog
          v-model="dialogCopy"
          width="317"
        >
          <v-form
            v-model="catalogueNameValid"
          >
            <v-card
              id="copy-link-dialog"
              class="copy-link-dialog"
            >
              <v-card-title class="copy-link-dialog__close pa-0">
                <v-btn
                  text
                  icon
                  depressed
                  class="ma-0"
                  @click="dialogCopy = false"
                >
                  <v-icon
                    small
                  >
                    mdi-close-thick
                  </v-icon>
                </v-btn>
              </v-card-title>

              <v-card-text class="copy-link-dialog__title  py-0">
                {{ sellerFirstName }}, catálogo gerado com sucesso!
              </v-card-text>

              <v-card-text v-if="!isMaxFavoriteCatalogues">
                Agora você também pode favoritar este
                catálogo para copiar o link quando quiser.
                Ele estará visível na sua lista de catálogos.
              </v-card-text>

              <v-card-text
                v-if="!isMaxFavoriteCatalogues"
                class="py-0 font-weight-bold"
              >
                Dê um nome para favoritar este catálogo:
                <v-text-field
                  v-model="favoriteCatalogueName"
                  placeholder="Exemplo de nome"
                  counter="28"
                  :rules="[rules.characterLimit]"
                />
              </v-card-text>

              <v-card-actions class="copy-link-dialog__actions px-0 py-4 ma-0">
                <v-btn
                  v-if="!isMaxFavoriteCatalogues"
                  class="copy-link-dialog__btn mb-2"
                  medium
                  depressed
                  color="#FFADDE"
                  :loading="loadingCopy"
                  :disabled="!canFavorite"
                  @click="favoriteAndCopyCatalogue"
                >
                  <v-icon
                    medium
                    class="mr-2"
                  >
                    $vuetify.icons.heartOutlineIcon
                  </v-icon>
                  Salvar catálogo como favorito
                </v-btn>
                <v-btn
                  depressed
                  dark
                  color="#140C22"
                  class="copy-link-dialog__btn mb-2"
                  style="z-index: 2;"
                  @click="whatsappCardExpand = !whatsappCardExpand"
                >
                  <v-icon
                    small
                    class="mr-2"
                  >
                    mdi-whatsapp
                  </v-icon>
                  Enviar por WhatsApp
                </v-btn>
                <v-expand-transition>
                  <v-card
                    v-show="whatsappCardExpand"
                    height="120"
                    width="288"
                    class="mx-auto mb-2 expand-card"
                  >
                    <v-form
                      v-model="validWhatsapp"
                    >
                      <v-flex
                        class="mx-4 my-4 expand-card-content"
                      >
                        <v-text-field
                          ref="phoneRef"
                          v-model="customerPhone"
                          mask="(##) #####-####"
                          placeholder="(xx) xxxx-xxxx"
                          :rules="[rules.required, rules.min]"
                          class="mr-3 phone-input"
                        />
                        <v-btn
                          block
                          :disabled="!validWhatsapp"
                          color="#140C22"
                          style="color: white; border-radius: 12px"
                          class="primary-btn"
                          @click="sendLinkToCustomer()"
                        >
                          Enviar
                        </v-btn>
                      </v-flex>
                    </v-form>
                  </v-card>
                </v-expand-transition>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>

        <v-btn
          v-if="getCustomer.salesAssistant"
          block
          depressed
          flat
          class="finish-btn px-1 mt-3"
          :loading="loadingCheckout"
          :disabled="loading
            || !hasProducts
            || getCatalogue.some((item) => item.status === 'PENDING')
            || getCatalogue.every((item) => item.status === 'DECLINED')
            || modifiedProducts.some((item) => item.modification === 'zeroStock')"
          @click="proceedToCheckout"
        >
          Finalizar Venda
        </v-btn>
        <!-- to be used in upcoming versions of sales assistant !-->
        <!-- <v-dialog
          v-model="dialogCheckout"
          width="317"
        >
          <v-card class="finish-order-dialog">
            <v-card-title class="finish-order-dialog__close pa-0">
              <v-btn
                text
                icon
                depressed
                class="ma-0"
                @click="dialogCheckout = false"
              >
                <v-icon
                  small
                >
                  mdi-close-thick
                </v-icon>
              </v-btn>
            </v-card-title>

            <v-card-text class="finish-order-dialog__title py-0">
              Pedido gerado com sucesso!
            </v-card-text>

            <v-card-text>
              Como você deseja prosseguir?
            </v-card-text>

            <v-card-actions class="finish-order-dialog__actions px-0 py-4 ma-0">
              <v-btn
                class="finish-order-dialog__btn mb-2"
                medium
                depressed
                dark
                color="#140C22"
                :href="checkoutLink"
                target="_blank"
              >
                <v-icon
                  medium
                  class="mr-2"
                >
                  mdi-account-multiple
                </v-icon>
                Venda Assistida
              </v-btn>
              <v-btn
                id="copyLink"
                class="finish-order-dialog__btn ma-0"
                outline
                depressed
                color="#140C22"
                @click="toggleQrCodeDialog"
              >
                <v-icon
                  medium
                  class="mr-2"
                >
                  mdi-account
                </v-icon>
                Self-Checkout
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog> -->
      </v-card-actions>
    </v-card>

    <!-- Dialog QRCode -->
    <v-dialog
      v-model="dialogQrCode"
      width="362"
    >
      <QrCodeDialog
        :close-dialog="() => { dialogQrCode = false }"
        :back-to-checkout="toggleQrCodeDialog"
      />
    </v-dialog>

    <v-dialog
      v-model="dialogReview"
      width="362"
      persistent
    >
      <ReviewCartDialog :close="() => dialogReview = false" />
    </v-dialog>

    <v-dialog
      v-model="dialogRedirect"
      persistent
      max-width="317"
    >
      <ActionsDialog
        dialog-text="O que deseja fazer?"
        first-text="Continuar editando"
        second-text="Retornar ao catálogo"
        :first-action="() => { dialogRedirect = false }"
        :second-action="() => backToCatalogue()"
        :close="() => { dialogRedirect = false }"
      />
    </v-dialog>

    <v-progress-circular
      v-if="loading"
      class="progress-circular"
      size="50"
      width="4"
      color="#140C22"
      indeterminate
    />
  </v-container>
</template>

<script>
import { everything } from '@sejazipper/layer-api-client';
import { mapGetters } from 'vuex';
import Promise from 'bluebird';
import { APIService } from '../resources/campanha';
import { FindAllTemplateCatalogue } from '../apollo';
import { EventBus } from '../event-bus';
import { useZipperApi } from '../composables/useZipperApi';
import CartProduct from '../components/Product/CartProduct.vue';
import ProductEditDialog from '../components/Product/ProductEditDialog.vue';
import WarrantyDialog from '../components/Product/WarrantyDialog.vue';
import WarrantyMobileDialog from '../components/Product/WarrantyMobileDialog.vue';
import ServicesDialog from '../components/Product/ServicesDialog.vue';
import ActionsDialog from '../components/ActionsDialog.vue';
import QrCodeDialog from '../components/QrCodeDialog.vue';
import ReviewCartDialog from '../components/Product/ReviewCartDialog.vue';
import DeclinedApprovalProduct from '../components/Product/DeclinedApprovalProduct.vue';

const shortid = require('shortid');

const api = new APIService();
const { client } = useZipperApi();

export default {
  components: {
    CartProduct,
    ProductEditDialog,
    WarrantyDialog,
    WarrantyMobileDialog,
    ServicesDialog,
    ActionsDialog,
    QrCodeDialog,
    ReviewCartDialog,
    DeclinedApprovalProduct,
  },

  data: () => ({
    catalogue: {},
    catalogueLink: null,
    loader: null,
    phone: null,
    loading: false,
    dialogCopy: false,
    dialogClear: false,
    dialogQrCode: false,
    dialogCheckout: false,
    dialogReview: false,
    dialogRedirect: false,
    productDialogs: {
      exclude: false,
      edit: false,
      services: false,
      warranty: false,
      warrantyMobile: false,
    },
    productToDialog: {},
    templateCatalogues: [],
    templateCatalogue: null,
    whatsappCardExpand: false,
    customerPhone: '',
    favoriteCatalogueFormValid: false,
    discountCode: '',
    sendToCustomerFormValid: true,
    rules: {
      required: (v) => !!v
        || 'Campo Obrigatório',
      min: (value) => (value && value.length === 11)
        || 'Número inválido',
      characterLimit: (v) => v.length <= 28 || 'Limite de caracteres atingido',
    },
    zeroStockRequests: [],
    favoriteCatalogueName: null,
    loadingCopy: false,
    loadingCheckout: false,
    catalogueNameValid: false,
    validWhatsapp: false,
    counter: 0,
    unitiesToApply: 0,
    checkout: {},
    warrantyActual: undefined,
    store: undefined,
  }),

  computed: {
    ...mapGetters([
      'getStore',
      'getCustomer',
      'getCatalogue',
      'getProfile',
      'isMaxFavoriteCatalogues',
      'getCatalogueId',
      'getPerson',
    ]),

    sellerFirstName() {
      const names = this.getProfile.name.trim().split(' ');

      return names[0];
    },

    sanitizedPhone() {
      if (!this.customerPhone) return null;
      return this.customerPhone.match(/\d/g).join('');
    },

    whatsappRedirect() {
      const text = encodeURI(`Olá! Acesse seu catálogo pelo link: ${this.catalogueLink}`);
      return `https://wa.me/+55${this.sanitizedPhone}?text=${text}`;
    },

    hasProducts() {
      return this.getCatalogue.length > 0;
    },

    isCatalogue() {
      return this.getCatalogueId && this.getCatalogueId.length === 9;
    },

    servicesTotalCost() {
      const productsServices = this.getCatalogue.map((product) => product.services);

      const total = productsServices.reduce(
        (totalCost, services) => {
          const totalByProduct = services && services.length
            ? services.reduce((acc, cur) => acc + cur.price, 0)
            : 0;

          return totalCost + totalByProduct;
        }, 0,
      );

      return total;
    },

    warrantiesTotalCost() {
      const warranty = this.getCatalogue.map((product) => (product.warranty ? product.warranty.price * product.quantity : 0));
      const warrantyMobile = this.getCatalogue.map((product) => (product.warrantyMobile ? product.warrantyMobile.price * product.quantity : 0));
      const totalWarranty = warranty.reduce(
        (totalCost, item) => totalCost + item, 0,
      );
      const totalWarrantyMobile = warrantyMobile.reduce(
        (totalCost, item) => totalCost + item, 0,
      );

      return totalWarranty + totalWarrantyMobile;
    },

    totalCost() {
      const productPrices = this.productsAccepted.map(
        (product) => (product.price || this.getStoreSkuPrice(product, 'regular')) * product.quantity,
      );
      const productsTotalCost = productPrices.reduce((totalCost, price) => totalCost + price, 0);

      return productsTotalCost + this.warrantiesTotalCost + this.servicesTotalCost;
    },

    canFavorite() {
      return !!this.favoriteCatalogueName
        && this.catalogueNameValid;
    },

    checkoutLink() {
      return `https://${this.getCustomer.nickname.toLowerCase()}.whts.shop/checkout/${this.checkout._id}`;
    },

    productsPending() {
      return this.getCatalogue.filter((product) => product.status && product.status === 'PENDING');
    },

    productsAccepted() {
      return this.getCatalogue.filter((product) => product.status !== 'DECLINED');
    },

    modifiedProducts() {
      return this.getCatalogue.filter((product) => product.modification);
    },

    getStoreOMS() {
      return this.store;
    },
  },

  watch: {
    loader() {
      const l = this.loader;
      this[l] = !this[l];

      // eslint-disable-next-line no-return-assign
      setTimeout(() => (this[l] = false), 1500);

      this.loader = null;
      this.alert = true;
    },

    getCustomer: {
      handler() {
        this.loader = 'loading';
        this.getTemplateCatalogues();
      },
      immediate: true,
    },

    dialogCopy(val) {
      if (!val) {
        const copyDialogElement = document.getElementById('copy-link-dialog');
        window.Clipboard.copy(this.catalogueLink, copyDialogElement);
        this.dialogCopy = false;
        this.emitSnackbar('Link do catálogo copiado para a área de transferência');
        this.$router.push('/produtos');
      }
    },

    productToDialog() {
      this.warrantyActual = this.productToDialog.warranty;
    },

    async getStore(store) {
      if (store) {
        await this.getProduct();
        this.store = await client.chain.query.findStoreByMongoId({
          mongoId: store.id,
        }).get({ ...everything });
      }
    },
  },

  async created() {
    this.store = await client.chain.query.findStoreByMongoId({
      mongoId: this.getStore.id,
    }).get({ ...everything });
  },

  async mounted() {
    if (this.modifiedProducts.length) this.dialogReview = true;
    this.approvalRequestHandler();
  },

  methods: {
    async approvalRequestHandler() {
      await Promise.map(this.productsPending, async (product) => {
        const res = await client.chain.query.getApprovalRequestById({
          approvalRequestId: product.approvalId,
        }).get({ status: true });
        this.$set(product, 'status', res.status);
      });
      if (this.productsPending.length !== 0) this.approvalRequestHandler();
    },

    async getTemplateCatalogues() {
      try {
        const res = await this.$apollo.query({
          query: FindAllTemplateCatalogue,
          variables: {
            // eslint-disable-next-line no-underscore-dangle
            customerId: this.getCustomer.id,
          },
          fetchPolicy: 'no-cache',
        });
        this.templateCatalogues = res.data.findAllTemplateCatalogue;
        this.templateCatalogue = this.templateCatalogues.find((el) => el.defaultTemplateCatalogue);
        if (this.templateCatalogue) {
          this.templateCatalogue.name = `${this.templateCatalogue.name} (padrão)`;
        }
      } catch (e) {
        EventBus.$emit('activeSnackBar', {
          text: 'Ocorreu um erro no sistema. Por favor, entre em contato com o suporte.',
          value: true,
          color: 'red',
        });
      }
    },

    emitSnackbar(text) {
      const snackBar = {};
      snackBar.value = true;
      snackBar.text = text;
      snackBar.color = '#140C22';
      snackBar.button = false;
      snackBar.icon = '$vuetify.icons.checkIcon';
      snackBar.class = {
        height: '120px',
        'font-size': '16px',
        'font-weight': '600',
        'justify-content': 'center',
      };
      EventBus.$emit('activeSnackBar', snackBar);
    },

    generateCatalogueURL(catalogueId) {
      if (this.getCustomer.nickname) {
        return `https://${this.getCustomer.nickname.toLowerCase()}.whts.shop/${catalogueId}`;
      }
      return `https://shop.sejazipper.com/${catalogueId}`;
    },

    async createCatalogue() {
      const catalogo = {
        id: shortid.generate(),
        storeId: this.getStore.id,
        customerId: this.getCustomer.id,
        sellerId: this.$auth.user.sub,
        templateCatalogueId: this.getCatalogueId,
        productIds: this.getCatalogue.map((product) => product.id),
      };
      this.catalogue = await api.createCatalogue(catalogo);
      this.catalogueLink = this.generateCatalogueURL(this.catalogue.id);
    },

    updateAndCopyCatalogue() {
      this.loadingCopy = true;
      const productIds = this.productsAccepted.map((product) => product.id);
      this.catalogue = client.chain.mutation
        .updateCatalogueProductIds({
          customerId: this.getCustomer.id,
          catalogueId: this.getCatalogueId,
          sellerId: this.$auth.user.sub,
          productIds,
        })
        .get(true)
        .then((res) => {
          this.catalogue = res;
        });
      this.catalogueLink = this.generateCatalogueURL(this.getCatalogueId);
      this.loadingCopy = true;
      this.copyCatalogueLink(true);
    },

    favoriteAndCopyCatalogue(event) {
      this.loadingCopy = true;
      client.chain.mutation
        .favoriteCatalogueByIdAndSellerId({
          customerId: this.getCustomer.id,
          catalogueId: this.catalogue.id,
          sellerId: this.$auth.user.sub,
          favoriteName: this.favoriteCatalogueName,
        })
        .get(true);
      this.loadingCopy = false;
      this.emitSnackbar('Catálogo salvo e link copiado para a área de transferência');
      this.copyCatalogueLink(false, event.target);
    },

    copyCatalogueLink(warn, targetElement) {
      this.favoriteCatalogueName = null;
      window.Clipboard.copy(this.catalogueLink, targetElement);
      this.dialogCopy = false;
      if (warn) this.emitSnackbar('Link copiado com sucesso');
      this.$router.push('/produtos');
    },

    async catalogueAction() {
      if (this.isCatalogue) {
        this.updateAndCopyCatalogue();
      }
      await this.createCatalogue();
      this.dialogCopy = true;
    },

    clearCheckout() {
      this.loader = 'loading';
      this.$store.dispatch('clearCheckout');
      this.dialogClear = false;
    },

    toggleProductDialog(product, dialog, value) {
      this.productToDialog = product;
      this.productDialogs[dialog] = value;
    },

    removeProduct(product) {
      this.loader = 'loading';
      this.$store.dispatch('removeCheckout', product);
      this.productDialogs.exclude = false;
    },

    sendLinkToCustomer() {
      const url = this.whatsappRedirect;
      window.open(url, '_blank');
      this.$refs.phoneRef.reset();
      this.customerPhone = '';
      this.whatsappCardExpand = false;
      this.dialogCopy = false;
    },

    toggleQrCodeDialog() {
      this.dialogQrCode = !this.dialogQrCode;
      this.dialogCheckout = !this.dialogCheckout;
    },

    async createCheckout() {
      const items = this.productsAccepted.map((product) => ({
        idERP: product.id.toString(),
        reference: product.reference,
        price: product.price,
        oldPrice: product.oldPrice || product.old_price,
        hasDiscount: product.hasDiscount,
        storeId: product.store_id,
        isCD: product.isCD,
        services: product.services,
        warranty: product.warranty,
        warrantyMobile: {
          ...product.warrantyMobile,
          imei: product.imei ? product.imei.match(/\d+/g).join('') : undefined,
        },
        sku: {
          idLoja: product.idLoja,
          sku_id: product.sku_id,
          size: product.size,
          color: product.color,
        },
        quantity: product.quantity,
      }));

      try {
        const checkout = await client.chain.mutation
          .createCheckout({
            checkout: {
              customerId: this.getCustomer.id,
              storeId: this.getStore.id,
              sellerId: this.getProfile.id,
              person: this.getPerson,
              sellerName: this.getProfile.name,
              items,
            },
          })
          .get({ ...everything });
        this.checkout = checkout;
      } catch (e) {
        console.log('GenQL Error', e);
      }
    },

    async proceedToCheckout() {
      this.loadingCheckout = true;
      this.checkout = { ...this.$route.params.checkout };
      if (!Object.keys(this.checkout).length) await this.createCheckout();
      this.$store.dispatch('setCheckoutLink', this.checkoutLink);
      this.loadingCheckout = false;
      window.open(this.checkoutLink, '_blank');
      this.dialogRedirect = true;
    },

    async applyDiscount() {
      EventBus.$emit('activeSnackBar', {
        text: 'Cupom de desconto inválido',
        value: true,
        color: 'red',
      });
    },

    getStoreSkuPrice(product, priceType) {
      const { oldPrice, price } = product.skus.find((sku) => sku.idLoja === this.getStore.id && sku.currentStock > 0) || {};

      const prices = {
        old: (oldPrice > price) ? oldPrice : null,
        regular: price,
      };

      return prices[priceType];
    },

    goBack() {
      window.history.back();
    },

    backToCatalogue() {
      this.$router.replace('/produtos');
      this.$store.commit('SET_CATALOGUE_FILTERS', []);
    },

    saveProduct() {
      const index = this.getCatalogue.findIndex(
        (product) => product.id === this.productToDialog.id
          && product.warranty === this.productToDialog.warranty
          && product.warrantyMobile === this.productToDialog.warrantyMobile
          && product.services === this.productToDialog.services,
      );
      let products = [];

      if (
        this.unitiesToApply > 0
          && (
            this.productToDialog.warranty
            || this.productToDialog.warrantyMobile
            || (this.productToDialog.services && this.productToDialog.services.length)
          )
      ) {
        products = this.splitProducts(this.productToDialog);
      }

      if (products.length) {
        this.getCatalogue.splice(index, 1);
        products.forEach((item) => {
          this.$store.dispatch('addToCatalogue', {
            ...item,
            warranty: item.warranty || undefined,
            warrantyMobile: item.warrantyMobile || undefined,
            services: item.services && item.services.length ? item.services : [],
          });
        });
      }
    },

    changeQuantityWarranty(quantity) {
      this.unitiesToApply = quantity;
    },

    splitProducts(product) {
      const item = { ...product };

      delete item.warranty;
      delete item.warrantyMobile;
      delete item.services;

      delete item.imei;
      delete item.imeis;

      const newProducts = [];

      if (product.imeis && product.imeis.length) {
        product.imeis.forEach((imei) => newProducts.push({ ...product, quantity: 1, imei }));
        if (item.quantity !== product.imeis.length) {
          newProducts.push({ ...item, quantity: item.quantity - product.imeis.length });
        }
      } else {
        if (product.services && product.services.length) {
          // eslint-disable-next-line no-plusplus
          for (let i = 0; i < this.unitiesToApply; i++) {
            newProducts.push({
              ...product,
              services: [...product.services],
              quantity: 1,
            });
          }
        } else {
          newProducts.push({
            ...product,
            quantity: this.unitiesToApply,
          });
        }

        if ((item.quantity - this.unitiesToApply) > 0) {
          newProducts.push({
            ...item,
            quantity: item.quantity - this.unitiesToApply,
          });
        }
      }

      return newProducts;
    },
  },
};
</script>

<style scoped lang="scss">

body {
  background: #e8eeff;
}

.products-catalogue-wrapper {
  display: block;
  margin-bottom: 20px;
}

.apply-discount {
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.15);
  &__title {
    text-align: left;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    font-family: 'Roboto', sans-serif;
    color: rgba(20, 12, 34, 0.87);
  }
  &__text_input {
    padding: 0px 0px 0px 16px;
    border: 1px solid rgba(20, 12, 34, 0.87);
    border-radius: 7px 0px 0px 7px;
    height: 32px;
    font-family: 'Nunito Sans';
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    color: rgba(20, 12, 34, 0.87);
  }
  &__button {
    font-family: 'Nunito Sans';
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    height: 32px;
    border-radius: 0px 7px 7px 0px;
    color: #fff;
    text-transform: capitalize;
    text-align: center;
    min-width: 65px;
  }
}

.apply-discount__text_input.v-text-field > .v-input__control > .v-input__slot {
  height: 23px;
}

.v-btn--icon.v-btn--small {
  width: 12px;
}

.v-card__actions .v-btn + .v-btn {
  margin-left: 0;
}

.expand-card {
  transform: translateY(-30px);
  z-index: 1;
  border: 1px solid #140C22;
  border-radius: 6px;
}

.expand-card-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  transform: translateY(15px);
}

.zerostock-warning {
  background: #140C22;
  border-radius: 4px;
  color: white;
  font-size: 12px;
  padding: 0.5rem 0.5rem;
}

.phone-input {
  height: 46px !important;
  padding-left: 5px;
  padding-bottom: 3px;
  border-radius: 6px;
}

.primary-btn {
  font-family: 'Nunito Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 42px;
  color: #140C22;
  border-radius: 7px !important;
  height: 46px;
  text-transform: none;
}

.generate-catalogue-btn {
  width: 82%;
  height: 48px;
  margin: 0 auto;
  font-family: 'Nunito Sans', sans-serif;
  font-weight: 600;
  font-size: 16px;
  color: #fff;
  text-transform: capitalize;
  border-radius: 7px;
}

.finish-btn {
  width: 82%;
  height: 48px;
  margin: 0 auto;
  font-family: 'Nunito Sans', sans-serif;
  font-weight: 600;
  font-size: 16px;
  color: #140C22;
  text-transform: capitalize;
  border: 1px solid #140C22;
  border-radius: 7px;
}

.progress-circular {
  height: 50vh !important;
}

.back-to-catalogue-btn {
  font-family: 'Neue-Metana';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 102%;
  text-transform: capitalize;
  width: auto;
  border-radius: 20px;
}

.cart {
  font-family: 'Nunito Sans';
  &__store-seller {
    text-align: left;
    font-weight: 500;
    font-size: 20px;
    font-family: 'Roboto', sans-serif;
  }
  &__size {
    text-align: left;
    font-size: 16px;
    font-weight: 600;
    color: #8A8691;
  }
  &__clear-btn {
    width: 144px;
    height: 30px;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    text-transform: none;
    border-radius: 39px;
    border: 1px solid;
  }
  &__empty {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #140C22;
    &__subtitle {
      font-weight: 600;
      font-size: 14px;
      line-height: 24px;
      text-align: center;
    }
  }
}

.order {
  &__summary {
    display: flex;
    flex-direction: column;
    &__title {
      text-align: left;
      font-weight: 700;
      font-size: 20px;
      font-family: 'Nunito Sans', sans-serif;
    }
  }
  &__total {
    font-weight: 700;
    font-size: 16px;
  }
  &__subtotal {
    font-size: 14px;
  }
}

.copy-link-dialog, .finish-order-dialog {
  width: 100%;
  font-family: 'Nunito Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  text-transform: none;
  border-radius: 7px;
  &__actions {
    display: flex;
    flex-flow: column wrap;
    align-items: center;
    height: auto;
  }
  &__btn {
    width: 288px;
    height: 42px;
    border-radius: 7.08982px;
    text-transform: none;
    font-weight: 600;
  }
  &__close {
    display: flex;
    justify-content: end;
  }
  &__title {
    font-size: 16px;
    font-weight: 700;
    line-height: 22px;
    color: #0C4439;
  }
}

::v-deep .v-responsive__content {
  max-width: fit-content;
}

::v-deep .apply-discount .v-btn--block {
  margin: 0px
}

::v-deep .apply-discount .v-text-field .v-input__control .v-input__slot {
  padding: 0px;
  margin: -9px;
  background: none;
}

::v-deep .v-dialog.product-edit-dialog {
  box-shadow: 0px 0.967175px 2.16647px rgba(0, 0, 0, 0.15);
  border-radius: 11.6061px;
}

::v-deep .v-input {
  font-family: 'Nunito Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 14px !important;
  line-height: 18px;
}

::v-deep .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
}

::v-deep .v-select__selections {
  padding-top: 5px !important;
}

::v-deep .v-input__slot {
  border-radius: 7px !important;
}

::v-deep .v-label {
  font-size: 15px !important;
}

::v-deep .v-expansion-panel {
  &__header {
    padding: 0px 24px;
  }
}

</style>
